var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.71 20.935c-1.109 1.026-2.318.864-3.482.378-1.232-.496-2.362-.518-3.662 0-1.628.67-2.487.475-3.459-.378C1.591 15.507 2.405 7.24 8.667 6.938c1.526.075 2.588.798 3.481.863 1.334-.259 2.611-1.004 4.035-.907 1.707.13 2.995.777 3.843 1.943-3.526 2.018-2.69 6.454.543 7.695-.645 1.619-1.481 3.227-2.871 4.414l.011-.01ZM12.034 6.873c-.17-2.407 1.876-4.393 4.227-4.587.328 2.785-2.645 4.857-4.227 4.587Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.90ec2a208e694fa8e40629e4c4d108f8.svg";
export { ForwardRef as ReactComponent };